/**
 *
 * @description  施工模板外的其他模板编辑
 *
 * */
import { Drawer, Button, message } from 'antd';
import { forwardRef, useImperativeHandle } from 'react';
import { driver } from 'driver.js';
import { useEventEmitter } from '&/utils/customHooks/useEventEmitter';
import LeftTreeMenu from '@/components/LeftTreeMenu/DrawerTree';
import DecorateToDoForm from '&/components/TemplateManagement/Modal/DecorateToDoForm';
import InspectionTemplate from '&/components/TemplateManagement/Modal/InspectionTemplateForm';
import AcceptanceTemplateForm from '&/components/TemplateManagement/Modal/AcceptanceTemplateForm';
import DefaultEmpty from '&/components/TemplateManagement/DefaultEmpty';
import quickStartGuide from '&/store/quickStartGuide';
import {
    verifyingTemplateContent,
    setDefaultTemplateEditData,
    treeDataTransformTemplateData,
    addInspect,
    removeInspect,
    addNotepad,
    removeNotepad,
    addExamine,
    removeExamine,
    regConstruction,
    saveTipModal,
} from '&/components/TemplateManagement/common';
import 'driver.js/dist/driver.css';
import './index.scss';

const TemplateSettingsModal = forwardRef((props, ref) => {
    const { templateData } = props;
    const {
        templateType = '',
        title,
        templateDetailData,
        menuList,
    } = templateData;
    const [visible, setVisible] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [updateType, setUpdateType] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);
    const [disabledStage, setDisabledStage] = useState(false);
    const [autoChangeSelectedKeys, setAutoChangeSelectedKeyss] = useState(true);

    const { emit } = useEventEmitter();

    useImperativeHandle(ref, () => {
        return { show, hide };
    });

    useEffect(() => {
        let timer = null;
        if (visible) {
            initModal();
            let tempType = '';
            if (templateType === 'decorateTemplate') {
                tempType = 'notepadTempPopup';
            } else if (templateType === 'inspectionTemplate') {
                tempType = 'examineTempPopup';
            }
            quickStartGuide.queryGuidance(tempType).then(data => {
                if (+data !== 0) return;
                timer = setTimeout(() => {
                    const upload = document.querySelector(
                        '.template-settings-modal .upload-file'
                    );
                    const checkbox = document.querySelector(
                        '.template-settings-modal .update-attachment-checkbox'
                    );
                    if (!upload || !checkbox) return;
                    const driverObj = driver({
                        disableActiveInteraction: true,
                        allowClose: false,
                    });
                    const skipFn = () => {
                        quickStartGuide.setGuidanceStatus(tempType, 2);
                        driverObj.destroy();
                    };

                    let title1 = '';
                    let description1 = '';
                    let title2 = '';
                    let description2 = '';
                    if (templateType === 'decorateTemplate') {
                        title1 = intl.get(
                            'quickStartGuidance.notePadTemp.title1'
                        );
                        description1 = intl.get(
                            'quickStartGuidance.notePadTemp.description1'
                        );
                        title2 = intl.get(
                            'quickStartGuidance.notePadTemp.title2'
                        );
                        description2 = intl.get(
                            'quickStartGuidance.notePadTemp.description2'
                        );
                    } else if (templateType === 'inspectionTemplate') {
                        title1 = intl.get(
                            'quickStartGuidance.examineTemp.title1'
                        );
                        description1 = intl.get(
                            'quickStartGuidance.examineTemp.description1'
                        );
                        title2 = intl.get(
                            'quickStartGuidance.examineTemp.title2'
                        );
                        description2 = intl.get(
                            'quickStartGuidance.examineTemp.description2'
                        );
                    }
                    driverObj.setSteps([
                        {
                            element: upload,
                            popover: {
                                title: title1,
                                description: description1,
                                side: 'bottom',
                                align: 'center',
                                nextBtnText: intl.get(
                                    'quickStartGuidance.button.next'
                                ),
                                showButtons: ['next'],
                                onPopoverRender: dom => {
                                    const { previousButton, footer } = dom;
                                    previousButton.style.display = 'none';
                                    const btnsWrap = footer.querySelector(
                                        '.driver-popover-navigation-btns'
                                    );
                                    const spanEle =
                                        document.createElement('span');
                                    spanEle.classList.add('skip-btn');
                                    spanEle.innerText = intl.get(
                                        'quickStartGuidance.button.skip',
                                        { current: 1, total: 2 }
                                    );
                                    spanEle.onclick = skipFn;
                                    btnsWrap.insertBefore(
                                        spanEle,
                                        btnsWrap.children[0]
                                    );
                                },
                            },
                        },
                        {
                            element: checkbox,
                            popover: {
                                title: title2,
                                description: description2,
                                side: 'bottom',
                                align: 'end',
                                doneBtnText: intl.get(
                                    'quickStartGuidance.button.done'
                                ),
                                prevBtnText: intl.get(
                                    'quickStartGuidance.button.previous'
                                ),
                                onPopoverRender: dom => {
                                    const { footer } = dom;
                                    const btnsWrap = footer.querySelector(
                                        '.driver-popover-navigation-btns'
                                    );
                                    const spanEle =
                                        document.createElement('span');
                                    spanEle.classList.add('skip-btn');
                                    spanEle.innerText = intl.get(
                                        'quickStartGuidance.button.skip',
                                        { current: 2, total: 2 }
                                    );
                                    spanEle.onclick = skipFn;
                                    btnsWrap.insertBefore(
                                        spanEle,
                                        btnsWrap.children[0]
                                    );
                                },
                                onNextClick: skipFn,
                            },
                        },
                    ]);
                    driverObj.drive();
                }, 500);
            });
        } else if (timer && !visible) {
            clearTimeout(timer);
            timer = null;
        }
    }, [visible]);

    useEffect(() => {
        visible && changeShowForm();
    }, [menuList, visible]);

    const show = () => {
        setVisible(true);
    };

    const hide = () => {
        setVisible(false);
    };

    const leftTreeMenuRef = useRef();

    const initModal = () => {
        if (templateDetailData) {
            const treeDetailsData = setDefaultTemplateEditData(
                templateDetailData,
                templateType
            );
            leftTreeMenuRef.current.onSelect(
                [treeDetailsData.id],
                treeDetailsData
            );
        } else {
            setTimeout(() => {
                leftTreeMenuRef.current.onAdd(null, true);
            }, 0);
        }
    };

    const verifyValue = value => {
        if (!regConstruction.test(value)) {
            const msg = intl.get('templateSettings.constructionStageErrorMsg');
            message.warning(msg);
            return false;
        }
        return true;
    };

    const verifySaveValue = (nodeData, treeData) => {
        let list = treeData;
        if (
            list
                .filter(item => item.key !== nodeData.key)
                .some(item => item.value === nodeData.value)
        ) {
            const msg = intl.get(
                'templateSettings.constructionStageCanNotRepeatMsg'
            );
            message.warning(msg);
            return false;
        }
        return true;
    };

    const beforeAddNode = option => {
        const { treeData } = option;
        let state = false;
        if (treeData.some(item => item.is_new === 1)) {
            message.warning(intl.get('templateSettings.haveSaveTemplateMsg'));
            state = true;
        }
        return state;
    };

    const updateTreeData = (treeData, newNode) => {
        setShowForm(!!treeData.length);
        setIsDisabled(treeData.some(item => item.is_new === 1));
    };

    const currentTemplateRef = useRef();

    const beforeChangeNode = async option => {
        const { keys, treeData } = option;

        let state = false;
        if (!keys.length) return state;

        // 当前表单数据？
        const nowSelectData =
            await currentTemplateRef.current?.getChangeValue();
        if (!nowSelectData) return true;

        const showCallback = async type => {
            const { keys, data, callback } = option;
            if (type === 'close') {
                callback(keys, data);
            } else {
                const hasError = await saveNode(true);
                if (!hasError) callback(keys, data);
            }
        };

        // form没有ID代表是本地的
        if (!nowSelectData.templateId) {
            saveTipModal(showCallback);
            state = true;
        } else {
            let originalData =
                treeData.filter(
                    item => item.id === nowSelectData.templateId
                )[0] || {};

            const isChanged = verifyingTemplateContent({
                templateType,
                oldData: originalData?.originalItem,
                newData: nowSelectData,
            });
            if (isChanged) {
                saveTipModal(showCallback);
                state = true;
            }
        }
        return state;
    };

    const selectNode = async (key, data) => {
        if (key?.length) {
            const formData = await treeDataTransformTemplateData(
                data,
                templateType,
                key
            );
            setDisabledStage(data?.node?.originalItem?.type === '1');
            setIsDisabled(!formData.constructionStage);
            currentTemplateRef.current?.setValue(formData);
        }
    };

    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(false);
    }, [templateData]);
    const saveNode = async hasChangeSelect => {
        try {
            let hasError = false;
            setLoading(true);
            const data = await currentTemplateRef.current?.getValue();
            if (data) {
                const addMap = {
                    acceptanceTemplate: addInspect,
                    decorateTemplate: addNotepad,
                    inspectionTemplate: addExamine,
                };
                await addMap[templateType](data);
                if (hasChangeSelect === true) {
                    setUpdateType('edit');
                } else {
                    setUpdateType(data.templateId ? 'edit' : 'add');
                }

                emit('query-template-list', {
                    templateType,
                });
            } else {
                setLoading(false);
                hasError = true;
            }
            return hasError;
        } catch {
            setLoading(false);
        }
    };

    const removeNode = async nodeData => {
        if (nodeData.is_new !== 1) {
            const removeTemplateTypeMap = {
                acceptanceTemplate: removeInspect,
                decorateTemplate: removeNotepad,
                inspectionTemplate: removeExamine,
            };
            setUpdateType('delete');
            await removeTemplateTypeMap[templateType](nodeData);
        }
        emit('query-template-list', { templateType });
    };

    const getResetTreeKey = (list, type, selectData) => {
        let key = [list[0].key];
        list.forEach(item => {
            if (item.key === selectData.parentKey) {
                key = [item.key];
                if (type === 'add' && item.children.length) {
                    key.push(item.children[item.children.length - 1]?.key);
                } else {
                    if (item.children.length) {
                        key.push(item.children[0].key);
                    }
                }
            }
        });
        return key;
    };

    const changeShowForm = () => {
        setShowForm(!!menuList?.length);
    };

    const addNode = () => {
        leftTreeMenuRef.current.onAdd(null, false);
    };

    let CurrentComponent = () => {};

    switch (templateType) {
        case 'acceptanceTemplate':
            CurrentComponent = AcceptanceTemplateForm;
            break;
        case 'decorateTemplate':
            CurrentComponent = DecorateToDoForm;
            break;
        case 'inspectionTemplate':
            CurrentComponent = InspectionTemplate;
            break;
        default:
            break;
    }

    return (
        <Drawer
            className="template-settings-modal"
            onClose={hide}
            visible={visible}
            width="760px"
            title={title}>
            <div className="template-settings-modal-content">
                {visible && (
                    <LeftTreeMenu
                        ref={leftTreeMenuRef}
                        autoChangeSelectedKeys={autoChangeSelectedKeys}
                        changeAutoChangeSelectedKeys={
                            setAutoChangeSelectedKeyss
                        }
                        treeMenuData={menuList}
                        initComponent={visible}
                        hasInterceptBeforeChangeNode={showForm}
                        getResetTreeKey={getResetTreeKey}
                        updateType={updateType}
                        menuOpt={{
                            menuTitle: title,
                            showTitleAdd: true,
                            beforeChangeNode,
                            beforeAddNode,
                            updateTreeData,
                            selectNode,
                            removeNode,
                            inputMaxLength: 15,
                            verifyValue,
                            verifySaveValue,
                        }}
                    />
                )}

                {showForm ? (
                    <>
                        {visible && (
                            <div className="content-box">
                                <CurrentComponent
                                    key={templateType}
                                    ref={currentTemplateRef}
                                    disabledForm={isDisabled}
                                    disabledStage={disabledStage}
                                />
                            </div>
                        )}

                        <div className="content-footer">
                            <Button onClick={hide}>
                                {intl.get('base.cancel')}
                            </Button>
                            <Button
                                type="primary"
                                loading={loading}
                                onClick={e => {
                                    e.stopPropagation();
                                    saveNode();
                                }}>
                                {intl.get('base.confirm')}
                            </Button>
                        </div>
                    </>
                ) : (
                    <DefaultEmpty
                        option={{
                            title: intl.get('templateSettings.emptyTemplate'),
                            addClick: addNode,
                        }}
                    />
                )}
            </div>
        </Drawer>
    );
});

export default TemplateSettingsModal;
